import { css } from 'styled-components';

// Translate from the base font size of the mockup (1rem = 16px)
// to plain px cause our base font size is 10px.
function rems(rem) {
   return 16 * rem + 'px;';
}

export default css`
   .campaign-container {
      display: flex;
      justify-content: center;
      min-height: 400px;
   }

   .campaign-image-container {
      display: flex;
      justify-content: center;
      width: 100%;
      background-size: cover;
      background-position: left center;
   }

   .campaign-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      max-width: 1352px;
      padding: 0 256px 0 0;
   }

   .campaign-new {
      margin-bottom: 8px;
      color: #1975f1;
      font-weight: 900;
      letter-spacing: 1px;
      text-transform: uppercase;
   }

   .campaign-title,
   .campaign-subtitle,
   .campaign-button {
      /* Fix for IE 11 text not wrapping */
      max-width: 100vw;
   }

   .campaign-title {
      font-family: 'Proxima Nova', 'Archivo Black', sans-serif;
      font-size: 40px;
      font-weight: bold;
      margin: 0;
   }

   .campaign-subtitle {
      font-family: 'Proxima Nova', Lato, Arial, sans-serif;
      font-size: 28px;
      font-weight: bold;
      margin: 8px 0 0;
   }

   .campaign-button {
      margin: 24px 0;
   }

   @media (max-width: 1400px) {
      .campaign-text {
         padding-left: 24px;
      }
   }

   @media (max-width: 991px) {
      .campaign-image-container {
         align-items: flex-start;
         background-position: right top;
      }
      .campaign-text {
         width: 100%;
         height: 100%;
         justify-content: center;
         align-items: center;
         padding-right: ${rems(5)};
         padding-left: ${rems(5)};
      }
      .campaign-title {
         text-align: center;
      }
      .campaign-subtitle {
         text-align: center;
      }
   }

   @media (max-width: 767px) {
      .campaign-container {
         height: auto;
         min-height: auto;
      }

      .campaign-text {
         padding: ${rems(5)};
      }
   }

   @media (max-width: 479px) {
      .campaign-text {
         padding-right: ${rems(2)};
         padding-left: ${rems(2)};
      }
   }
`;
